"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.NavigationListBuilder = exports.GetTestMapId = void 0;
var FooterStyles = _interopRequireWildcard(require("./FooterStyles"));
var _BackToTop = _interopRequireDefault(require("../BackToTop/BackToTop"));
var _ImportedContentFragment = _interopRequireDefault(require("./../ContentFragments/ImportedContentFragment"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _SocialMediaList = _interopRequireDefault(require("./../SocialMediaList/SocialMediaList"));
var _classnames = _interopRequireDefault(require("classnames"));
var _string = require("../../utils/type-checks/string");
var _styles = require("@mui/material/styles");
var _material = require("@mui/material");
var _react = _interopRequireWildcard(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const merge = require("deepmerge"),
  GetTestMapId = testId => {
    return {
      component: (0, _string.isStringOfLength)(testId) ? testId : undefined,
      copyright: (0, _string.isStringOfLength)(testId) ? `${testId}__copyright` : undefined,
      navMenu: (0, _string.isStringOfLength)(testId) ? `${testId}__menu` : undefined
    };
  },
  NavigationListBuilder = props => {
    const {
        customNavigationListSx = {},
        item = {
          type: "children",
          value: "test content"
        },
        theme,
        testId
      } = props,
      {
        type,
        value
      } = item,
      defaultNavigationListSx = FooterStyles.DefaultNavigationListSx(theme),
      defaultStyles = merge(defaultNavigationListSx, customNavigationListSx);
    return /*#__PURE__*/_react.default.createElement(_material.Box, {
      sx: defaultStyles,
      "data-testid": testId
    }, type === "fragment" && /*#__PURE__*/_react.default.createElement(_ImportedContentFragment.default, {
      id: value
    }), type === "children" && value);
  };

/**
 * Sitewide Page Footer Component
 *
 * @visibleName Page Footer
 * @author [Jeff Stevens](mailto:jeffrey.stevens@pheaa.org)
*/
exports.NavigationListBuilder = NavigationListBuilder;
exports.GetTestMapId = GetTestMapId;
const Footer = props => {
  const {
      backToTopConfig = {},
      bottomNavFragment = "zcae7h",
      bundledStyles = {},
      copyrightFragment = "ztwf9o",
      customTheme = {},
      hasMargin = true,
      logo = {
        alt: "The Pennsylvania Higher Education Assistance Agency",
        src: `${process.env.PUBLIC_URL}/general/images/footer/logo.svg`,
        height: "5.4rem",
        width: "13.7rem"
      },
      MediaList = _SocialMediaList.default,
      navigationFragmentArray = [{
        type: "fragment",
        value: "zs9sxa"
      }, {
        type: "fragment",
        value: "zs565m"
      }, {
        type: "fragment",
        value: "zsqbm8"
      }],
      testId,
      variant = "default"
    } = props,
    testIdMap = GetTestMapId(testId),
    theme = merge((0, _styles.useTheme)(), customTheme),
    {
      customBottomNavStyles = {},
      customContainerStyles = {},
      customCopyrightSx = {},
      customInnerContainerSx = {},
      customLogoStyles = {},
      customLogoImageStyles = {},
      customNavigationStyles = {}
    } = bundledStyles,
    compiledClassNames = (0, _classnames.default)({
      "footer": true,
      "footer--noMarginTop": !hasMargin,
      "footer--noNavigation": variant === "no-navigation"
    }),
    bottomNavSx = merge(FooterStyles.DefaultBottomNavSx(theme, variant), customBottomNavStyles),
    containerSx = merge.all([FooterStyles.DefaultContainerSx(theme, variant), customContainerStyles]),
    copyrightSx = merge(FooterStyles.DefaultCopyrightSx(theme, variant), customCopyrightSx),
    innerContainerSx = merge(FooterStyles.DefaultInnerContainerSx(theme, variant), customInnerContainerSx),
    logoStyles = merge.all([{
      height: logo.height,
      width: logo.width
    }, FooterStyles.DefaultLogoStyles(theme, variant), customLogoStyles]),
    logoImageStyles = merge.all([{
      height: logo.height,
      width: logo.width
    }, FooterStyles.DefaultLogoImageStyles(theme, variant), customLogoImageStyles]),
    navigationFlexSx = merge(FooterStyles.DefaultNavigationSx(theme, variant), customNavigationStyles);
  return /*#__PURE__*/_react.default.createElement(_react.Fragment, null, variant !== "no-navigation" && /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement(_material.Container, {
    component: "footer",
    "data-testid": testIdMap.component,
    sx: containerSx,
    id: "footer",
    className: compiledClassNames,
    role: "contentinfo"
  }, /*#__PURE__*/_react.default.createElement(_material.Grid, {
    container: true,
    sx: innerContainerSx
  }, /*#__PURE__*/_react.default.createElement(_material.Grid, {
    item: true,
    xs: 12,
    md: 8
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    component: "nav",
    sx: navigationFlexSx,
    "aria-label": "Secondary Navigation",
    "data-testid": testIdMap.navMenu
  }, navigationFragmentArray.map((item, i) => /*#__PURE__*/_react.default.createElement(NavigationListBuilder, {
    key: `navList_${i}`,
    item: item,
    theme: theme
  })))), /*#__PURE__*/_react.default.createElement(_material.Grid, {
    item: true,
    xs: 12,
    md: 4,
    sx: copyrightSx,
    "data-testid": testIdMap.copyright
  }, /*#__PURE__*/_react.default.createElement(_material.Card, {
    component: "h2",
    sx: logoStyles
  }, /*#__PURE__*/_react.default.createElement(_material.CardMedia, {
    alt: logo.alt,
    className: "footer__logo",
    component: "img",
    sx: logoImageStyles,
    src: logo.src
  })), /*#__PURE__*/_react.default.createElement(_ImportedContentFragment.default, {
    id: copyrightFragment
  }), MediaList && /*#__PURE__*/_react.default.createElement(MediaList, {
    customTheme: customTheme
  }))), /*#__PURE__*/_react.default.createElement(_BackToTop.default, _extends({}, backToTopConfig, {
    customTheme: customTheme
  }))), /*#__PURE__*/_react.default.createElement(_material.Container, {
    component: "nav",
    className: "footer__bottom-navigation",
    sx: bottomNavSx,
    "aria-label": "Sitewide Footer Links"
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    sx: innerContainerSx
  }, /*#__PURE__*/_react.default.createElement(_ImportedContentFragment.default, {
    id: bottomNavFragment
  })))), variant === "no-navigation" && /*#__PURE__*/_react.default.createElement(_material.Container, {
    component: "footer",
    "data-testid": testIdMap.component,
    sx: containerSx,
    id: "footer",
    className: compiledClassNames,
    role: "contentinfo"
  }, MediaList && /*#__PURE__*/_react.default.createElement(MediaList, {
    customTheme: customTheme
  }), /*#__PURE__*/_react.default.createElement(_material.Container, {
    component: "nav",
    className: "footer__bottom-navigation",
    sx: bottomNavSx,
    "aria-label": "Sitewide Footer Links"
  }, /*#__PURE__*/_react.default.createElement(_ImportedContentFragment.default, {
    id: bottomNavFragment
  })), /*#__PURE__*/_react.default.createElement(_material.Box, {
    sx: copyrightSx,
    "data-testid": testIdMap.copyright
  }, /*#__PURE__*/_react.default.createElement(_ImportedContentFragment.default, {
    id: copyrightFragment
  })), /*#__PURE__*/_react.default.createElement(_BackToTop.default, _extends({}, backToTopConfig, {
    customTheme: customTheme
  }))));
};
Footer.propTypes = {
  /** Configuration object for BackToTop component */
  backToTopConfig: _propTypes.default.shape({
    minScroll: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.number]),
    triggerHeight: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.number])
  }),
  /** Content fragment ID for navigation at base of footer (Default Value: "zcae7h") */
  bottomNavFragment: _propTypes.default.string,
  /** Collection of custom stylles objects (Default Value: {}) */
  bundledStyles: _propTypes.default.shape({
    /** Custom styles for sitewide links at base of footer */
    customBottomNavStyles: _propTypes.default.object,
    /** Custom styles for outer footer container */
    customContainerStyles: _propTypes.default.object,
    /** Custom styles for copyright block */
    customCopyrightSx: _propTypes.default.object,
    /** Custom styles for inner footer container */
    customInnerContainerSx: _propTypes.default.object,
    /** Custom styles for logo block */
    customLogoStyles: _propTypes.default.object,
    /** Custom styles for logo image */
    customLogoImageStyles: _propTypes.default.object,
    /** Custom Styles for Navigation block (including copyright and media list sections) */
    customNavigationStyles: _propTypes.default.object,
    /** Custom styles for Site Map Navigation List */
    customNavigationListSx: _propTypes.default.object
  }),
  /** Content fragment ID for copywright notification (Default Value: "ztwf9o") */
  copyrightFragment: _propTypes.default.string,
  /** Custom theme injection (Default Value: {}) */
  customTheme: _propTypes.default.object,
  /** Indicator if Footer has top margin (Default Value: true) */
  hasMargin: _propTypes.default.bool,
  /** Object describing footer logo attributes */
  logo: _propTypes.default.shape({
    /** Alt Text (Default Value: "The Pennsylvania Higher Education Assistance Agency") */
    alt: _propTypes.default.string,
    /** Image SRC URL (Default Value: "/general/images/footer/logo.svg") */
    src: _propTypes.default.string,
    /** Image Height (Default Value: "5.4rem") */
    height: _propTypes.default.string,
    /** Image Width (Default Value: "13.7rem") */
    width: _propTypes.default.string
  }),
  /** Element node / React component used for branding logos or social media links (Default Value: SocialMediaList component) */
  MediaList: _propTypes.default.any,
  /** Array of objects describing Navigation Site Map section (Default Value: array of sample fragments) */
  navigationFragmentArray: _propTypes.default.arrayOf(_propTypes.default.shape({
    /** Type identifier for element */
    type: _propTypes.default.oneOf(["fragment", "children"]),
    /** Node (if chidren element) or string (if fragment ID) */
    value: _propTypes.default.any
  })),
  /** @ignore */
  testId: _propTypes.default.string
};
NavigationListBuilder.propTypes = {
  customNavigationListSx: _propTypes.default.object,
  item: _propTypes.default.shape({
    type: _propTypes.default.oneOf(["fragment", "children"]),
    value: _propTypes.default.any
  }),
  theme: _propTypes.default.object.isRequired,
  testId: _propTypes.default.string,
  variant: _propTypes.default.oneOf(["default", "no-navigation"])
};

// Export component as default;
var _default = exports.default = Footer;